import FooterComp from "../components/footer";
import Nav from "../components/nav";
import "../css/landing.css"
import underline from "../media/pen-underline.png"
import "aos/dist/aos.css";
import Aos from "aos";
import { useNavigate } from "react-router-dom";
import Fonav from "../components/fonnav";
import quotation from "../media/quotation.png"
import "../css/fonnav.css"
import useGenStore from "../store/store";
import { useEffect } from "react";
function Landing(){
    const navigate= useNavigate()
  const menuActive = useGenStore((s)=>s.menuActive)
  const toContact =()=>{
    navigate("/contact")
  }
    useEffect(() => {
    Aos.init({ duration: 400 });
  }, []);
  useEffect(()=>{
   console.log(menuActive)
  },[menuActive])

    return(
        <>
        <helmet>
        <title>James McCanna | Employment & Labor Law Attorney</title>
        <meta
          name="description"
          content="Employment law attorney James McCanna helps workers & employers with fair treatment, compliance & workplace issues. Free consultation."
        />
      </helmet>
        <div className="floatBtn">
            <button onClick={()=>( window.location.href = "tel:+13602974057")}>Call Now</button>
        </div>

        <div className= {`floatNav ${menuActive ? "floatNavActive" : " "}`} >
            <Fonav />
        </div>
        <section className="hero">

            <div className="heroWrap">
                <div className="heroWrapLayer">
            <nav>
            <Nav />

            </nav>
            <div className="heroCont">
                <div className="heroContLeft">
                    <span>Because workers</span>
                    <h1>MATTER.</h1>
                    <img src={underline} alt="" />
                </div>
                <div className="heroContRight">
                     <button onClick={()=>toContact()}>Schedule A Consultation</button>
                </div>
            </div>

    
            </div>
            </div>
           
       
        </section>
        <section className="Honourable">
            <div className="honourablePlacer">
                   <div className="hounarableTitle">
                    <span>All work is</span>
                    <h2>HONORABLE</h2>
                    <img src={underline} alt="" />

                   </div>
                   <div className="honourableSection">
                    <img src={quotation} alt="" />
                    <p>Here is what I believe. All work is honorable, and all workers and employers appreciate the contribution
of the employee and what the employer provides. The vast majority of those employed spend more
time at the job with their co-workers than they do with their own families. For many, it is the focus of
their lives and is central to their well-being. Having a job is not only necessary in our world but also
gives a sense of purpose. Workers are people who deserve respect. 

</p>
<p>Employers who employ them deserve respect as well.

It is my goal to make sure that all employees are fairly treated irrespective of their gender, age, race,
ethnicity, national origin, sexual preference and social status. I am willing to work with employees and
employers alike to accomplish this.</p>
<p>I recognize that employers need to pay attention to the bottom-line and to pursue efficiency in the
workplace to meet profit goals and business needs. The challenges in the current economic
environment demand a thoughtful approach to meet legal needs at the same time promoting the health
of the business. The temptation to take shortcuts or to put off current issues until later is very strong. </p>
<p>All too often, shortcuts are mistaken for efficiency, and knee-jerk reactions are considered decisive.

Many studies have shown that happy, well-paid workers make more money for their employers than
unhappy under-paid employees. So, there is a balance to be struck. I can help you get there too and
enhance your bottom line through effective, fair and proper employment practices.</p>

  <div className="signoff">
                    <p>James McCanna</p>
                                       <button onClick={()=>(navigate("/services"))}>View Services</button>

                   </div>

                   </div>
                 
            </div>


        </section>
        <section className="grids">
            <div className="gridsWrap">
                <div className="gridBox gridBox1 pressCard" data-aos="fade-up" >
                    <div className="gridCont">
                        <h3><span>My </span>Approach</h3>
                        <p>While it is obvious that lawyers need to know the law I believe the most important "skill" a
lawyer should have is the ability and commitment to listen. Listening is the door to
understanding. Understanding is the key to effective representation. A lawyer cannot
effectively represent a client until the lawyer understands the issues, the environment
from which the issue arises and the needs of the client. I know that good advice must be
preceded by effective listening. This goes for employees and employers.</p>
                    </div>
                </div>
                <div className="gridBox gridBox2 pressCard" data-aos="fade-up" >
                    <div className="gridCont">
                        <h3><span>Free </span>Initial Consultation</h3>
                        <p>Contact me for an initial confidential
consultation to determine if your need and
my skills are a good fit. I only take work that
I know will provide superior value to my
clients.</p>
<p>If I cannot help you I am happy to provide a
referral that will work for you.</p>
                    </div>
                </div>
                <div className="gridBox gridBox3 pressCard" data-aos="fade-up">
                    <div className="gridCont">
                        <h3><span>My </span>Promise</h3>
                        <p>I will listen first. I will ask probing questions
to enhance my understanding. </p>
<p>I will give you the best advice I can based on
my 27 years of experience.</p>

                    </div>
                </div>
            </div>

        </section>
             <footer>
                <FooterComp />
            </footer>

      </>


    )
}

export default Landing;